import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import routes from './routes';

function Router({ isLogged }) {
	const filteredRoutes = isLogged ? routes : routes.filter((r) => !r.isLogged);
	// const browserRouter = createBrowserRouter(filteredRoutes, { basename: '/chkinweb/west_qa/dev' }); // qa dev
	// const browserRouter = createBrowserRouter(filteredRoutes, { basename: '/chkinweb/west_qa' }); // qa
	const browserRouter = createBrowserRouter(filteredRoutes, { basename: '/check-in' }); // prd
	// const browserRouter = createBrowserRouter(filteredRoutes); // local
	return (
		<RouterProvider router={browserRouter} />
	);
}

export default Router;
